import { render, staticRenderFns } from "./AgeAtFirstDiagnosisPercentageChart.vue?vue&type=template&id=2283364f"
import script from "./AgeAtFirstDiagnosisPercentageChart.vue?vue&type=script&lang=ts"
export * from "./AgeAtFirstDiagnosisPercentageChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports